import { httpCreate } from './http';

const http = httpCreate('/srv/activity-invite-detail');

export const activityInviteDetail = {
	getInviteDetail({ activityId, userId, ...params }) {
		return http.get(`/${activityId}/list/${userId}`, { params: params });
	},
};
